import { render, staticRenderFns } from "./DeleteReplyModal.vue?vue&type=template&id=541c95c6&"
import script from "./DeleteReplyModal.vue?vue&type=script&lang=js&"
export * from "./DeleteReplyModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports